import { SearchOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { isEmpty, isFunction } from 'lodash';
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import config from '../../common/config';
import { DOCUMENT_CLICK, emitter } from '../../common/helpers/ui/EventHelper';
import { searchPageUrlGenerator } from '../../common/helpers/routing/urlGenerator';
import commonResource from '../../locales/th/common.json';
import { trackFreeTextSearch } from '../../common/analytics/analyticsTracker';
import { SearchButtonWrapper } from './DesktopSearch.style';
import DesktopSearchInput from './DesktopSearchInput';

function DesktopSearch() {
  const [active, setActive] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const suggestionRef = useRef(null);
  const currentSourcePage = useSelector((state) =>
    state.search !== undefined ? state.search.currentSourcePage : '',
  );
  const searchButtonText = commonResource.search;
  const userInfo = useSelector((state) =>
    state !== undefined ? state.common.user : {},
  );

  useEffect(() => {
    const handleDocumentClick = () => {
      if (isEmpty(searchValue)) {
        setActive(false);
      }
    };

    if (config.isBrowser) {
      emitter.on(DOCUMENT_CLICK, handleDocumentClick);
    }

    return () => {
      if (config.isBrowser) {
        emitter.off(DOCUMENT_CLICK, handleDocumentClick);
      }
    };
  }, [searchValue]);

  const updateSearchValue = (searchValue) => {
    setSearchValue(searchValue);
  };

  const updateSearchActive = (active) => {
    setActive(active);
  };

  const handleClickSearch = (e) => {
    e.stopPropagation();
    if (isFunction(e.nativeEvent.stopImmediatePropagation)) {
      e.nativeEvent.stopImmediatePropagation();
    }
    if (active) {
      if (isEmpty(searchValue)) {
        setActive(false);
      } else {
        const baseUrl = searchPageUrlGenerator();
        window.location.href = `${baseUrl}?q=${searchValue}`;
        trackFreeTextSearch(userInfo, currentSourcePage, searchValue);
      }
    } else {
      setActive(true);
    }
  };
  return (
    <SearchButtonWrapper data-test={'desktop-search'}>
      <button
        className={classnames('btn-search', { active })}
        onClick={handleClickSearch}
      >
        <SearchOutlined />
        <span className="text">{searchButtonText}</span>
      </button>

      <CSSTransition
        in={active}
        timeout={300}
        classNames="fade"
        unmountOnExit
        nodeRef={suggestionRef}
      >
        <div ref={suggestionRef}>
          <DesktopSearchInput
            updateSearchValue={updateSearchValue}
            updateSearchActive={updateSearchActive}
            currentSourcePage={currentSourcePage}
          />
        </div>
      </CSSTransition>
    </SearchButtonWrapper>
  );
}

export default DesktopSearch;
